import { useFieldArray, useFormContext } from "react-hook-form";
import Addicon from "@mui/icons-material/Add";
import TrashLineIcon from "remixicon-react/DeleteBin2LineIcon";
import { createUseStyles } from "react-jss";
import Divider from "@mui/material/Divider";
import { theme } from "$utils/theme/bataillog";
import CField, { CFieldInputProps } from "$forms/CField";
import { CompanyType, MonStockConfigType, WMSConfigType } from "$types";
import { Button, Text } from "$components";
import useJStyles from "$hooks/useJStyles";
import CompanySelect from "$forms/CompanySelect";
import MonStockWarehouseSelect from "$forms/MonStockWarehouseSelect";
import { RenderWarehouse } from "./RenderWarehouse";

function MonStockConfig() {
  const { jclasses } = useJStyles();
  const classes = useStyles();
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext<WMSConfigType<MonStockConfigType>>();
  const {
    fields: providersFields,
    remove: removeProvider,
    insert: insertProvider,
  } = useFieldArray({
    control,
    name: "config.providers",
  });
  const { fields: warehouseProvidersFields } = useFieldArray({
    control,
    name: "config.warehouseProviders",
  });

  const token = watch("config.token");

  return (
    <div>
      <div className={classes.newFormFieldsRow}>
        <CField
          label="Clé d'identification"
          control={control}
          name="config.token"
          required
          error={errors?.config?.token}
        />
      </div>

      <Divider />
      <Text type="h3">Association entre entrepôts et fournisseurs</Text>
      {warehouseProvidersFields.map((provider, index) => (
        <div className={classes.newFormFieldsRow} key={provider.id}>
          <div className={classes.newFormFieldsCol}>
            <CField
              style={{
                width: "95%",
              }}
              control={control}
              name={`config.warehouseProviders.${index}.warehouseId`}
              required
              error={errors.config?.warehouseProviders?.[index]?.warehouseId}
            >
              {(props: CFieldInputProps) => {
                return <RenderWarehouse id={props.value} />;
              }}
            </CField>
          </div>
          <div className={classes.newFormFieldsCol}>
            <CField
              style={{ width: "95%" }}
              disabled={!token}
              label="Code fournisseur"
              control={control}
              name={`config.warehouseProviders.${index}.code`}
              required
              error={errors.config?.warehouseProviders?.[index]?.code}
            >
              {(props: CFieldInputProps) => (
                <MonStockWarehouseSelect
                  {...props}
                  token={token}
                  key={props.value}
                />
              )}
            </CField>
          </div>
        </div>
      ))}

      <Divider />
      <Text type="h3">Association entreprises</Text>
      {providersFields.map((provider, index) => (
        <div className={classes.newFormFieldsRow} key={provider.id}>
          <div className={classes.newFormFieldsCol}>
            <CField
              style={{ width: "95%" }}
              control={control}
              name={`config.providers.${index}.companyId`}
              required
              error={errors.config?.providers?.[index]?.companyId}
            >
              {(props: CFieldInputProps) => (
                <CompanySelect
                  {...props}
                  companyTypes={[CompanyType.CLIENT]}
                  placeholder=""
                  key={props.value}
                  minCharsToTrigerSearch={0}
                  rowsPerPage={99999}
                />
              )}
            </CField>
          </div>
          <div className={classes.newFormFieldsCol}>
            <CField
              style={{ width: "95%" }}
              label="Code fournisseur"
              control={control}
              name={`config.providers.${index}.code`}
              required
              error={errors.config?.providers?.[index]?.code}
            />
          </div>
          <Button
            color="primary"
            onClick={() => {
              removeProvider(index);
            }}
            style={{
              color: theme.color.red,
              alignItems: "end",
              maxWidth: 50,
            }}
          >
            <TrashLineIcon />
          </Button>
        </div>
      ))}
      {providersFields.length === 0 && (
        <Button
          className={jclasses.jAddCta}
          variant="outlined"
          onClick={async () => {
            insertProvider(providersFields.length, { companyId: "", code: "" });
          }}
        >
          <Addicon />
          Ajouter une nouvelle association
        </Button>
      )}
    </div>
  );
}

export default MonStockConfig;

const useStyles = createUseStyles(() => ({
  newFormFieldsRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
    gap: theme.spacing(1),
  },
  newFormFieldsCol: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
}));
